import { z } from "zod";

export const preMediaClientRequestDetailsFormSchema = z.object({
  preMediaBrief: z.string().min(1),
  preMediaFiles: z
    .array(
      z.object({
        fileSignedId: z.string().optional(),
        blobId: z.string().optional(),
        isDeleted: z.boolean().optional(),
        fileName: z.string().optional(),
        size: z.number().optional(),
        url: z.string().optional(),
      })
    )
    .min(0),
});

export type PreMediaClientRequestDetailsFormSchema = z.infer<
  typeof preMediaClientRequestDetailsFormSchema
>;
